/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AreaDetails: [
      'CooperationDetails',
      'HubDetails',
      'InFieldBreakDetails',
      'ShortBreakDetails',
    ],
    BackofficeUserResult: ['BackofficeUser', 'BackofficeUserLimited'],
    CampaignStateTransitionResponse: [
      'CampaignSendBackToDraftResponse',
      'CampaignSendForApprovalResponse',
      'CampaignStartTestResponse',
      'CampaignStopResponse',
      'CampaignStopTestResponse',
      'CampaignValidateResponse',
    ],
    CursorListResponse: [
      'CampaignsQueryResponse',
      'FccAuditLogList',
      'VehicleChangeList',
    ],
    FccUpdateAdPoolingStatusStatus: [
      'FccUpdateAdPoolingStatusFailure',
      'FccUpdateAdPoolingStatusSuccess',
    ],
    FccWaypointAction: [
      'FccWaypointDeliveryAction',
      'FccWaypointHubReturnAction',
      'FccWaypointPickupAction',
      'FccWaypointReallocationAction',
    ],
    FleetEntityChange: [
      'BoxPcReplacedChange',
      'BoxPcWipedChange',
      'CameraReplacedChange',
      'CdisBoxReplacedChange',
      'KeyRfidReplacedChange',
      'RouterReplacedChange',
      'TabletPhoneNumberReplacedChange',
      'TabletReplacedChange',
      'VehicleAttributeUpdatedChange',
      'VehicleCapacityOverriddenChange',
      'VehicleCapacityUpdatedChange',
      'VehicleCreatedChange',
      'VehicleServiceAbortedChange',
      'VehicleStateUpdatedChange',
      'VehicleUpdatedChange',
    ],
    FleetProcess: [
      'MainInspectionProcess',
      'MileageBasedInspectionProcess',
      'VICProcess',
    ],
    Geometry: ['MultiPolygon', 'Shape'],
    GraphQLGeniusResult: [
      'GraphQLGeniusOperationResult',
      'GraphQLGeniusRawResult',
    ],
    IBackofficeUserIdentity: [
      'BackofficeUser',
      'BackofficeUserIdentity',
      'BackofficeUserLimited',
    ],
    ListResponse: [
      'CampaignSensorsResponse',
      'CampaignServicesResponse',
      'CampaignSignalsResponse',
      'CustomPriceConfigsResponse',
      'DefaultPriceConfigsResponse',
      'DsBossScenariosResponse',
      'TaskNotificationList',
      'VehicleHubArrivalsResponse',
    ],
    PaymentMethod: ['ApplePay', 'CreditCard', 'GooglePay', 'PayPal'],
    RioComponent: [
      'RioComponentCheckbox',
      'RioComponentDate',
      'RioComponentDateTime',
      'RioComponentExternalLink',
      'RioComponentGeolocation',
      'RioComponentOptions',
      'RioComponentPassFail',
      'RioComponentRadioButtonGroup',
      'RioComponentSimple',
      'RioComponentStaticValue',
      'RioComponentStatus',
      'RioComponentTextArea',
      'RioComponentTroublemaker',
    ],
    SearchResultItemV3: [
      'SearchResultAreaItemV3',
      'SearchResultRoadBlockageItemV3',
      'SearchResultStopItemV3',
      'SearchResultTurnRestrictionItemV3',
    ],
    ShiftStateLogRecord: [
      'AreaLogRecord',
      'PoolingStateChangedLogRecord',
      'SendVehicleToHubLogRecord',
      'ShiftChangedLogRecord',
      'ShiftStateBreakLogRecord',
      'ShiftStateHubLogRecord',
      'ShiftStateShortBreakLogRecord',
      'ShiftStateVehicleLogRecord',
    ],
    TaskNotification: [
      'HubServiceNotification',
      'IvcTaskNotification',
      'PassengerAuthentificationFallbackRequestedNotification',
      'PassengerUnbuckled',
      'RoadBlockageTaskNotification',
      'ShiftDeviationNotification',
      'StopAccessibilityDownvotedByDrivers',
      'StopActivationFailedNotification',
      'StopAreaMissingActiveStopsNotification',
      'StopDownVotedByDrivers',
      'StopPotentiallyUnreachable',
      'StopValidationFailed',
      'TimeManagementNotification',
      'TripPrebookingNoAssignment',
      'VehicleAvailabilityNotification',
      'VehicleIncidentNotification',
      'VehicleSurveillanceNotification',
      'VehicleWaypointAttendance',
    ],
    VehicleChangeFields: [
      'BoxPcReplacedChangeFields',
      'BoxPcWipedChangeFields',
      'CameraReplacedChangeFields',
      'CdisBoxReplacedChangeFields',
      'KeyRfidReplacedChangeFields',
      'RouterReplacedChangeFields',
      'TabletPhoneNumberReplacedChangeFields',
      'TabletReplacedChangeFields',
      'VehicleAttributeUpdatedChangeFields',
      'VehicleCapacityOverriddenChangeFields',
      'VehicleCapacityUpdatedChangeFields',
      'VehicleCreatedChangeFields',
      'VehicleServiceAbortedChangeFields',
      'VehicleStateUpdatedChangeFields',
      'VehicleUpdatedChangeFields',
    ],
  },
}
export default result
